import date from 'date-and-time';

export class AvailabilityComparison {
  constructor(dates, min_age, max_age) {
    this.dates = dates
    this.min_age = min_age
    this.max_age = max_age
  }

  resolve() {
    let ages = this.dates[date.format(new Date(), 'YYYY-MM-DD')]
    if(ages) {
      return ages.find(function(age) {
        return age.max >= this.max_age && age.min <= this.min_age && age.count > 0
      }, this) != undefined
    } else {
      return false
    }
  }
}
